import React from 'react';
import { Dialog } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import theme from '../../../styles/theme';
import { useStyles } from './AppDialog.styles';

const AppDialog = (props) => {
  const { children, open, onClose, title, classes: customClasses = {} } = props;
  const { classes } = useStyles(theme);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: customClasses.root || classes.appDialogWrapper }}>
      <div className={classes.appDialogHeader}>
        <div className={classes.appDialogHeaderTitle}>{title}</div>
        <CloseIcon onClick={onClose} />
      </div>
      <div className={classes.appDialogContent}>{children}</div>
    </Dialog>
  );
};

export default AppDialog;
